import { useEffect, useState } from 'react';
import { applyAppearance, storedAppearance } from './AppearanceSettings';

function portalAppearance() {
  const value = storedAppearance();
  // Keep explicit preferences; new portal visitors start in the app's warm light theme.
  try { if (!localStorage.getItem('marvin.workbench.appearance.v1')) return { ...value, theme: 'light' as const }; }
  catch { /* Appearance remains usable when browser storage is unavailable. */ }
  return value;
}

export function usePortalAppearance() {
  const [appearance, setAppearance] = useState(portalAppearance);
  useEffect(() => {
    const update = () => { const value = portalAppearance(); setAppearance(value); applyAppearance(value); };
    const media = matchMedia('(prefers-color-scheme: dark)');
    update();
    window.addEventListener('marvin-appearance', update); media.addEventListener('change', update);
    return () => { window.removeEventListener('marvin-appearance', update); media.removeEventListener('change', update); };
  }, []);
  return appearance;
}
